export const correctUsageProxy = (usage, proxyType) => {
  const trimmedUsage = usage.trim();
  if (proxyType === "MOBILE") {
    return false;
  }
  return trimmedUsage.length < 3 || /^\d+$/.test(trimmedUsage);
};
